<p class="section-head-kicker">
  <span class="groove-arc-swash">{{ kicker() }}</span>
</p>
@if (level() === 1) {
  <h1 [id]="headingId()" class="groove-type-display section-head-heading">
    {{ heading() }}
  </h1>
} @else {
  <h2 [id]="headingId()" class="groove-type-display section-head-heading">
    {{ heading() }}
  </h2>
}
